export default __webpack_public_path__ + "static/media/nuit.8af65aca.svg";